import type { Key } from '@react-types/shared';
import { CASE_PATH_TO_TAB, CASE_TAB_TO_PATH, DEFAULT_CASE_TAB_KEY, DEFAULT_CASE_TAB_PATH } from './case-tabs.constants';

export const getCaseCurrentSubRoute = (pathname: string, caseId: string) => {
  const base = `/case/${caseId}/`;

  if (!pathname.startsWith(base)) {
    return DEFAULT_CASE_TAB_PATH;
  }

  const rest = pathname.slice(base.length);
  const segment = rest.split('/')[0];

  return segment || DEFAULT_CASE_TAB_PATH;
};

export const getCaseSelectedTabKey = (subRoute: string): Key => {
  return (CASE_PATH_TO_TAB[subRoute as keyof typeof CASE_PATH_TO_TAB] ?? DEFAULT_CASE_TAB_KEY) as Key;
};

export const getCaseTabPath = (tabKey: string) => {
  return CASE_TAB_TO_PATH[tabKey] ?? DEFAULT_CASE_TAB_PATH;
};

export const getCaseTabNavigatePath = (caseId: string, tabKey: string, search = '') => {
  const subPath = getCaseTabPath(tabKey);
  return `/case/${caseId}/${subPath}${search}`;
};
